import React from 'react';
import AuthService from './authService.js';
import SystemAlertItem from '../Domain/SystemAlertItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import SearchParams from '../Elements/SearchParams';
import SystemAlertSearchParams from '../Contents/SystemAlertAdmin/SystemAlertSearchParams';

class SystemAlertService extends React.Component
{
  static GetListBySearching (orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false)
  {
    const authService = AuthService.getInstance();

    let url = '/api/SystemAlert/GetBySearchParams/?';
    const searchParams = new SearchParams(searchItem, SystemAlertSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;
    return authService.CallBackendFunction(url);
  }

  static GetSystemAlerts ()
  {
    const authService = AuthService.getInstance();
    const user = AuthService.getInstance().GetLoggedInUser();
    const url = `/api/SystemAlert/GetAllForLoggedInUserAsync?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static GetSystemAlertForPopup ()
  {
    const authService = AuthService.getInstance();
    const user = AuthService.getInstance().GetLoggedInUser();
    const url = `/api/SystemAlert/GetForPopupAsync?clearCache=true`;
    return authService.CallBackendFunction(url);
  }

  static DismissSystemAlert (systemAlertId)
  {
    const authService = AuthService.getInstance();
    const url = `/api/SystemAlert/DismissSystemAlertAsync`;
    const jsonString = `{ "AlertId": "${systemAlertId}" }`;
    return authService.CallBackendFunctionPut(url, jsonString);
  }

  static ConvertDBItemList (items)
  {
    const convertedItems = [];

    if (items !== null)
    {
      items.forEach((item) =>
      {
        const newItem = new SystemAlertItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static UpsertSystemAlert (item)
  {
    item = serviceHelper.ConvertAllPropertyToString(item);
    return AuthService.getInstance().CallBackendFunctionPut('/api/SystemAlert/EditSystemAlertAsync', JSON.stringify(item));
  }


}

export default SystemAlertService;
